import { render, staticRenderFns } from "./AdditionalInfos.vue?vue&type=template&id=45e55489&scoped=true&lang=html&"
import script from "./AdditionalInfos.vue?vue&type=script&lang=js&"
export * from "./AdditionalInfos.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInfos.vue?vue&type=style&index=0&id=45e55489&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e55489",
  null
  
)

export default component.exports